<template>
  <div>
    <v-row
      v-for="row in rowsArray"
      :key="row"
      dense
      align="center"
      class="mb-3"
    >
      <v-col v-for="col in colsArray" :key="col">
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "FormLargeSkeletonLoader",
  props: {
    rows: {
      type: Number,
      default: 3,
    },
    cols: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    rowsArray() {
      return this.lodash.range(this.rows);
    },
    colsArray() {
      return this.lodash.range(this.cols);
    },
  },
};
</script>

<style scoped></style>
